import React, { useMemo } from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { sortBy } from 'lodash';
import { NonDismissibleDialog } from '@scoir/modals';
import { SortableListBox, SortableListBoxOption } from '@scoir/sortable-listbox';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import { Clear } from '@material-ui/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';
import { Link } from 'react-router-dom';

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function () {};
      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var ColumnsVisibilitySearch = function ColumnsVisibilitySearch(_ref) {
  var columnSearch = _ref.columnSearch,
    setColumnSearch = _ref.setColumnSearch;
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Typography, {
    component: "h3",
    variant: "h6"
  }, "Add Columns"), /*#__PURE__*/React.createElement(Box, {
    pb: 2,
    mt: 2
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "column-search-input",
    placeholder: "Search for columns",
    fullWidth: true,
    size: "small",
    variant: "outlined",
    value: columnSearch,
    onChange: function onChange(e) {
      setColumnSearch(e.target.value);
    },
    inputProps: {
      'aria-label': 'Search for columns'
    },
    InputProps: {
      startAdornment: ( /*#__PURE__*/React.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React.createElement(Box, {
        color: "text.secondary",
        display: "inline-flex"
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faSearch
      })))),
      endAdornment: ( /*#__PURE__*/React.createElement(IconButton, {
        title: "Clear",
        "aria-label": "Clear",
        size: "small",
        style: {
          visibility: columnSearch ? 'visible' : 'hidden'
        },
        onClick: function onClick() {
          setColumnSearch('');
        }
      }, /*#__PURE__*/React.createElement(Clear, null)))
    }
  })));
};

var Footer = NonDismissibleDialog.Footer;
var useStyles$2 = makeStyles(function (theme) {
  return createStyles({
    footer: {
      borderTop: "1px solid ".concat(theme.palette.divider),
      padding: '10px',
      position: 'sticky',
      bottom: 0,
      backgroundColor: theme.palette.background.paper,
      zIndex: 1
    }
  });
});
var ColumnsDialogFooter = function ColumnsDialogFooter(_ref) {
  var toggleAllColumnsVisibility = _ref.toggleAllColumnsVisibility,
    onClose = _ref.onClose;
  var classes = useStyles$2();
  return /*#__PURE__*/React.createElement(Footer, {
    className: classes.footer
  }, /*#__PURE__*/React.createElement(Box, {
    padding: 1,
    display: "flex",
    justifyContent: "space-between",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    size: "large",
    color: "primary",
    onClick: function onClick() {
      return toggleAllColumnsVisibility(false);
    }
  }, "Remove all columns"), /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    size: "large",
    color: "primary",
    onClick: function onClick() {
      return toggleAllColumnsVisibility(true);
    }
  }, "Add all columns")), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: onClose
  }, "Done")));
};

var Body = NonDismissibleDialog.Body;
var useStyles$1 = makeStyles(function (theme) {
  return createStyles({
    paperWidthMd: {
      maxWidth: '800px'
    },
    modalHeader: {
      background: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },
    columnVisibility: _defineProperty({}, theme.breakpoints.up('sm'), {
      borderRight: "1px solid ".concat(theme.palette.divider)
    }),
    list: {
      padding: 0,
      marginTop: 1
    },
    colOrderBtn: {
      height: '30px',
      width: '70px',
      display: 'flex',
      alignSelf: 'center'
    }
  });
});
var ColumnsManagementBody = function ColumnsManagementBody(_ref) {
  var columns = _ref.columns,
    columnSectionOrderModel = _ref.columnSectionOrderModel,
    columnVisibilityModel = _ref.columnVisibilityModel,
    setColumns = _ref.setColumns,
    setColumnVisibilityModel = _ref.setColumnVisibilityModel,
    onClose = _ref.onClose;
  var classes = useStyles$1();
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    columnSearch = _React$useState2[0],
    setColumnSearch = _React$useState2[1];
  var orderColumns = useMemo(function () {
    return columns.filter(function (i) {
      return i.isVisible;
    });
  }, [columns]);
  var onColumnReorder = function onColumnReorder(startingIdx, targetIdx) {
    if (startingIdx === targetIdx) return;
    var localColumns = _toConsumableArray(columns);
    //find what column is being moved and what column is being displaced
    var columnToMove = orderColumns[startingIdx];
    var destinationColumn = orderColumns[targetIdx];
    //find the target index in the larger columns array
    var destinationInMasterColumns = columns.findIndex(function (c) {
      return c.field === destinationColumn.field;
    });
    //remove the column that's moving, then insert it in the desired location
    localColumns = localColumns.filter(function (c) {
      return c.field !== columnToMove.field;
    });
    localColumns.splice(destinationInMasterColumns, 0, columnToMove);
    setColumns(localColumns);
  };
  var onColumnAddRemove = function onColumnAddRemove(column) {
    var newColumns = columns.map(function (c) {
      var localColumn = Object.assign({}, c);
      if (c.field === column.field) {
        localColumn.isVisible = !column.isVisible;
      }
      return localColumn;
    });
    var newVisibilityModel = Object.assign({}, columnVisibilityModel);
    newVisibilityModel[column.field] = !columnVisibilityModel[column.field];
    setColumns(newColumns, false);
    setColumnVisibilityModel(newVisibilityModel);
  };
  var toggleAllColumnsVisibility = function toggleAllColumnsVisibility(bool) {
    var hideableColumns = [];
    var newColumns = columns.map(function (c) {
      var localColumn = Object.assign({}, c);
      if (localColumn.hideable === false) {
        hideableColumns.push(localColumn.field);
      } else {
        localColumn.isVisible = bool;
      }
      return localColumn;
    });
    var newVisibilityModel = Object.assign({}, columnVisibilityModel);
    for (var visible in newVisibilityModel) {
      if (hideableColumns.includes(visible)) continue;
      newVisibilityModel[visible] = bool;
    }
    setColumns(newColumns, false);
    setColumnVisibilityModel(newVisibilityModel);
  };
  var columnSections = useMemo(function () {
    var sectionsWithColumns = (columnSectionOrderModel || []).map(function (section) {
      return {
        sectionTitle: section,
        columns: []
      };
    });
    //sort the columns so that the drag and drop re-order doesn't affect this side
    var localColumns = _toConsumableArray(sortBy(columns, ['defaultSortIndex']));
    if (columnSearch !== '') {
      var caseInsensitiveSearch = columnSearch.toLowerCase();
      localColumns = localColumns.filter(function (column) {
        var _a;
        return [column.headerName, column.section, (_a = column.longHeaderName) !== null && _a !== void 0 ? _a : ""].some(function (matchable) {
          return matchable.toLowerCase().includes(caseInsensitiveSearch);
        });
      });
    }
    // build array of sections so that each section has a sectionTitle and an array of columns
    var _iterator = _createForOfIteratorHelper(localColumns),
      _step;
    try {
      var _loop = function _loop() {
        var localColumn = _step.value;
        var sectionIndex = sectionsWithColumns.findIndex(function (a) {
          return (a === null || a === void 0 ? void 0 : a.sectionTitle) === localColumn.section;
        });
        //if the section is already present, add the column
        if (sectionIndex > -1) {
          sectionsWithColumns[sectionIndex].columns.push(localColumn);
        } else {
          //if the section doesn't exist yet, add it
          sectionsWithColumns.push({
            sectionTitle: localColumn.section,
            columns: [localColumn]
          });
        }
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return sectionsWithColumns.filter(function (section) {
      return section.columns.length > 0;
    });
  }, [columns, columnSearch, columnSectionOrderModel]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Body, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 6
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    className: classes.columnVisibility
  }, /*#__PURE__*/React.createElement(ColumnsVisibilitySearch, {
    columnSearch: columnSearch,
    setColumnSearch: setColumnSearch
  }), /*#__PURE__*/React.createElement(Box, null, columnSections.length > 0 ? ( /*#__PURE__*/React.createElement(List, {
    disablePadding: true,
    dense: true
  }, columnSections.map(function (section) {
    return /*#__PURE__*/React.createElement(ListItem, {
      disableGutters: true,
      key: section.sectionTitle
    }, /*#__PURE__*/React.createElement(Box, {
      width: "100%",
      my: 2
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      component: "h3"
    }, section.sectionTitle), /*#__PURE__*/React.createElement(List, {
      disablePadding: true,
      dense: true,
      "aria-label": "".concat(section.sectionTitle, " columns")
    }, section.columns.map(function (column) {
      return /*#__PURE__*/React.createElement(ListItem, {
        disableGutters: true,
        key: column.field
      }, /*#__PURE__*/React.createElement(Box, {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: 'center'
      }, /*#__PURE__*/React.createElement(Typography, {
        id: "col-m-dialog-".concat(column.field)
      }, column.longHeaderName ? column.longHeaderName : column.headerName), column.hideable === false ? null : ( /*#__PURE__*/React.createElement(Button, {
        "aria-describedby": "col-m-dialog-".concat(column.field),
        color: column.isVisible ? 'secondary' : 'primary',
        variant: "text",
        onClick: function onClick() {
          return onColumnAddRemove(column);
        }
      }, column.isVisible ? 'Remove' : 'Add'))));
    }))));
  }))) : ( /*#__PURE__*/React.createElement(Box, {
    my: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    component: "h3"
  }, "No matching columns"))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    component: "h3"
  }, "Manage Columns"), /*#__PURE__*/React.createElement(SortableListBox, {
    ariaLabel: "Order Columns List",
    className: classes.list,
    onDrop: onColumnReorder
  }, orderColumns.map(function (column, index) {
    return /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      justifyContent: "space-between",
      key: index
    }, /*#__PURE__*/React.createElement(SortableListBoxOption, {
      name: column.headerName,
      index: index,
      key: column.field
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, column.longHeaderName ? column.longHeaderName : column.headerName)), column.hideable === false ? null : ( /*#__PURE__*/React.createElement(Button, {
      size: "small",
      color: 'secondary',
      onClick: function onClick() {
        return onColumnAddRemove(column);
      },
      "data-testid": "col-vis-btn-".concat(column.field),
      className: classes.colOrderBtn
    }, "Remove")));
  }))))), /*#__PURE__*/React.createElement(ColumnsDialogFooter, {
    toggleAllColumnsVisibility: toggleAllColumnsVisibility,
    onClose: onClose
  }));
};
var ColumnsManagementDialog = function ColumnsManagementDialog(_ref2) {
  var columns = _ref2.columns,
    columnSectionOrderModel = _ref2.columnSectionOrderModel,
    columnVisibilityModel = _ref2.columnVisibilityModel,
    setColumns = _ref2.setColumns,
    setColumnVisibilityModel = _ref2.setColumnVisibilityModel,
    onClose = _ref2.onClose,
    open = _ref2.open;
  var classes = useStyles$1();
  return /*#__PURE__*/React.createElement(NonDismissibleDialog, {
    open: open,
    headerText: "Column Management",
    onClose: onClose,
    maxWidth: "md",
    headerClassName: classes.modalHeader,
    classes: {
      paperWidthMd: classes.paperWidthMd
    }
  }, /*#__PURE__*/React.createElement(ColumnsManagementBody, {
    columns: columns,
    columnSectionOrderModel: columnSectionOrderModel,
    columnVisibilityModel: columnVisibilityModel,
    setColumns: setColumns,
    setColumnVisibilityModel: setColumnVisibilityModel,
    onClose: onClose
  }));
};

var useStyles = makeStyles(function (theme) {
  return {
    nameContainer: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    nameCellContainer: {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      '&:hover $previewButton': {
        opacity: 1,
        position: 'relative'
      }
    },
    previewButton: {
      // Visually hide it and remove from DOM flow by default. These are inverted on parent hover and focus.
      position: 'absolute',
      opacity: 0,
      padding: '4px 10px',
      background: 'var(--info-states-outlined-hover-background, rgba(33, 150, 243, 0.08))',
      color: theme.palette.info.dark,
      marginLeft: 'auto',
      '&:focus': {
        opacity: 1,
        position: 'relative'
      },
      '&:hover': {
        boxShadow: 'none',
        background: 'rgba(33, 150, 243, 0.20)'
      }
    }
  };
});
var PreviewNameCell = function PreviewNameCell(_ref) {
  var crest = _ref.crest,
    name = _ref.name,
    link = _ref.link,
    setPreview = _ref.setPreview,
    data = _ref.data,
    endIcon = _ref.endIcon,
    text = _ref.text;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Box, {
    className: classes.nameCellContainer
  }, crest, link ? ( /*#__PURE__*/React.createElement(Link, {
    to: link,
    className: classes.nameContainer
  }, name)) : ( /*#__PURE__*/React.createElement(Box, {
    className: classes.nameContainer
  }, name)), /*#__PURE__*/React.createElement(Button, {
    className: "".concat(classes.previewButton),
    variant: "contained",
    onClick: function onClick(e) {
      e.stopPropagation();
      setPreview === null || setPreview === void 0 ? void 0 : setPreview(data);
    }
  }, text ? text : 'Preview'), endIcon);
};

export { ColumnsManagementDialog, PreviewNameCell };
//# sourceMappingURL=index.module.js.map
